class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
    
    // Change description for selected variant 
    
    var selectedVarId = this.currentVariant.id,
        productDesc = document.querySelectorAll('.product__variant-description'),
        productVarMaterial =  document.querySelectorAll('.product__variant-material'),
        productVarPreOrder =  document.querySelectorAll('.pre-order-text-variant'),
        productVarCustomTxt =  document.querySelectorAll('.msg-text'),
        productVarSize = document.querySelectorAll('.product__variant-size');

    if(selectedVarId == 26663041531968 || selectedVarId == 39715367649343 || selectedVarId == 26662448889920 || selectedVarId == 39733226864703 || selectedVarId == 39733226897471 || selectedVarId == 39771378483263 || selectedVarId == 39491615359039 || selectedVarId == 39890227494975 || selectedVarId == 39652777132095 || selectedVarId == 39890228609087 || selectedVarId == 32335645933631 ) {
      $(document).find('.eligible-text').css('display','block');
    } else {
      $(document).find('.eligible-text').css('display','none');
    }

    if (selectedVarId == 39518561402943 || selectedVarId == 39491615359039) {
      $(document).find('.discount-messaging').css('display','none');
    } else {
      $(document).find('.discount-messaging').css('display','block');
    }

    // if (selectedVarId == 39518561402943 || selectedVarId == 39491615359039) {
    //   $(document).find('.product-red-text-sale').removeClass('hide');
    // } else {
    //   $(document).find('.product-red-text-sale').addClass('hide');
    // }
    
    if(productDesc.length > 0) {
      for (var i = 0; i < productDesc.length; i++) {
        productDesc[i].classList.add('hide');
      }
      //document.querySelector('.product__variant-description[data-variant-id="' + selectedVarId + '"]').classList.remove('hide');

      document.querySelectorAll('.product__variant-description[data-variant-id="' + selectedVarId + '"]').forEach(function (item) {
        item.classList.remove('hide');
      });

      for (var i = 0; i < productVarMaterial.length; i++) {
        productVarMaterial[i].classList.add('hide');
      }
      //document.querySelector('.product__variant-material[data-variant-id="' + selectedVarId + '"]').classList.remove('hide');

      document.querySelectorAll('.product__variant-material[data-variant-id="' + selectedVarId + '"]').forEach(function (item) {
        item.classList.remove('hide');
      });
      
      for (var i = 0; i < productVarSize.length; i++) {
        productVarSize[i].classList.add('hide');
      }
      //document.querySelector('.product__variant-size[data-variant-id="' + selectedVarId + '"]').classList.remove('hide');

      document.querySelectorAll('.product__variant-size[data-variant-id="' + selectedVarId + '"]').forEach(function (item) {
        item.classList.remove('hide');
      });
    }
    
    for (var i = 0; i < productVarPreOrder.length; i++) {
      productVarPreOrder[i].classList.add('hide');
    }
    for (var i = 0; i < productVarCustomTxt.length; i++) {
      productVarCustomTxt[i].classList.add('hide');
    }

    var selectedPreOrderVariant = document.querySelector('.pre-order-text-variant[data-variant-id="' + selectedVarId + '"]').textContent;
    selectedPreOrderVariant = selectedPreOrderVariant.replace('Preorder: ', '');
    
    if (selectedPreOrderVariant.trim() === '') {
      document.getElementById('preOrderProperty').disabled = true;
    } else {
      document.getElementById('preOrderProperty').disabled = false;
    }
    
    document.getElementById('preOrderProperty').value = selectedPreOrderVariant;
    
    document.querySelector('.pre-order-text-variant[data-variant-id="' + selectedVarId + '"]').classList.remove('hide');
    document.querySelector('.msg-text[data-variant-id="' + selectedVarId + '"]').classList.remove('hide');
    
    var invPolicy = document.querySelector('.pre-order-text-variant[data-variant-id="' + selectedVarId + '"]').dataset.inventoryPolicy,
        variantText = document.querySelector('.pre-order-text-variant[data-variant-id="' + selectedVarId + '"]').innerText;
    
    if(invPolicy == 'deny' && variantText == '') {
      document.querySelector('.join-waitlist-link').style.display = 'block';
    } else {
      document.querySelector('.join-waitlist-link').style.display = 'none';
    }
  }

  updateMedia() {
    
    if (!this.currentVariant || !this.currentVariant?.featured_media) return;
    const newMedia = document.querySelector(
      `[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`
    );
        
    if (!newMedia) return;
    const parent = newMedia.parentElement;
    parent.prepend(newMedia);
    window.setTimeout(() => { parent.scroll(0, 0) });
  }

  updateURL() {
    if(document.body.contains(document.querySelector('.section--featured-product'))){
      console.log('Element exists!');
    } else {
      if (!this.currentVariant) return;
      window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
    }
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant?.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  renderProductInfo() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const id = `price-${this.dataset.section}`;
        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destination = document.getElementById(id);
        const source = html.getElementById(id);

        if (source && destination) destination.innerHTML = source.innerHTML;

        document.getElementById(`price-${this.dataset.section}`)?.classList.remove('visibility-hidden');
        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);

        window.loyaltylion && window.loyaltylion.ui.refresh();
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const addButton = document.getElementById(`product-form-${this.dataset.section}`)?.querySelector('[name="add"]');
    const buttonKlaviyo = document.getElementById(`product-form-${this.dataset.section}`)?.querySelector('[name="klaviyo"]');

    var selectedId = this.currentVariant.id;
    var inventoryQty = document.querySelector('.pre-order-text-variant[data-variant-id="' + selectedId + '"]').dataset.inventoryQuantity,
        inventoryPolicy = document.querySelector('.pre-order-text-variant[data-variant-id="' + selectedId + '"]').dataset.inventoryPolicy;

if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', true);
      if (text) addButton.textContent = text;

      document.querySelector('.shipping-estimate').classList.add('hide');

    } else {
      addButton.removeAttribute('disabled');

      if(this.currentVariant.id == document.querySelector('.pre-order-text.pre-order-text-variant:not(.hide)').dataset.variantId && document.querySelector('.pre-order-text.pre-order-text-variant:not(.hide)').innerText != '') {
        addButton.textContent = window.PreOrder.PreOrder;
        document.querySelector('.shipping-estimate').classList.add('hide');
      } else {
        addButton.textContent = window.variantStrings.addToCart;
        document.querySelector('.shipping-estimate').classList.remove('hide');
      }
    }

     if(buttonKlaviyo && modifyClass){
       if (disable) {
         addButton.style.display = "none";
         buttonKlaviyo.style.display = "flex";
       } else {
         addButton.style.display = "flex";
         buttonKlaviyo.style.display = "none";
      }
     }
    
    if (!modifyClass) return;
  }

  setUnavailable() {
    const addButton = document.getElementById(`product-form-${this.dataset.section}`)?.querySelector('[name="add"]');
    if (!addButton) return;
    addButton.textContent = window.variantStrings.unavailable;
    document.getElementById(`price-${this.dataset.section}`)?.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);